import { render, staticRenderFns } from "./seo-content-collapsible.vue?vue&type=template&id=567ebaf3&scoped=true&"
import script from "./seo-content-collapsible.vue?vue&type=script&lang=js&"
export * from "./seo-content-collapsible.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=567ebaf3&scoped=true&lang=css&"
import style1 from "./seo-content-collapsible.vue?vue&type=style&index=1&id=567ebaf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567ebaf3",
  null
  
)

export default component.exports